__turbopack_context__.v({
  "active": "style-module-scss-module__IMccxq__active",
  "component": "style-module-scss-module__IMccxq__component",
  "disclaimer": "style-module-scss-module__IMccxq__disclaimer",
  "filter": "style-module-scss-module__IMccxq__filter",
  "filters": "style-module-scss-module__IMccxq__filters",
  "highlighted-link": "style-module-scss-module__IMccxq__highlighted-link",
  "link-to-sitemap": "style-module-scss-module__IMccxq__link-to-sitemap",
  "list": "style-module-scss-module__IMccxq__list",
  "subtext": "style-module-scss-module__IMccxq__subtext",
});
